export default {
    bind(el, binding) {
        const titleNode = el.getElementsByClassName('ark-steps-main')[0].getElementsByClassName('ark-steps-title')
        titleNode[0].innerHTML = binding.value
    }
  }
